import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import WarningRounded from '@mui/icons-material/WarningRounded';
import CheckCircleOutlineRounded from '@mui/icons-material/CheckCircleOutlineRounded';
import NewReleasesIcon from '@mui/icons-material/NewReleases';

function MessageBox({
  header,
  alarmMessage,
  color,
  variant = 'warning',
}: {
  header?: string;
  alarmMessage: string | React.ReactNode;
  color: 'red' | 'gray';
  variant?: 'warning' | 'check' | 'new';
}) {
  return (
    <Grid item className="MessageBox__Grid">
      <Box
        display="flex"
        paddingY={1.75}
        paddingX={1.5}
        borderRadius={1.5}
        className={color === 'red' ? 'bp-bg-rose-0' : 'bp-bg-gray-0'}
        alignItems="flex-start"
      >
        {variant === 'warning' && <WarningRounded className="bp-self-start bp-fill-orange-30" />}
        {variant === 'check' && (
          <CheckCircleOutlineRounded
            className="bp-mt-1 bp-self-start bp-fill-status-success"
            fontSize="small"
          />
        )}
        {variant === 'new' && <NewReleasesIcon className="bp-fill-blue-50" />}
        <Box marginLeft={1} paddingRight={0.5}>
          {header && (
            <Typography variant="body2" className="bp-font-bold" marginBottom={0.5}>
              {header}
            </Typography>
          )}
          <Typography variant="body2">{alarmMessage}</Typography>
        </Box>
      </Box>
    </Grid>
  );
}

export default MessageBox;
